import { dataScan } from 'dls-icons-data'
import { createIcon } from '../common'

const IconScan = /*#__PURE__*/createIcon(dataScan)
export default IconScan
